import React from 'react';
import PropTypes from 'prop-types';
import Button from '@components/common/button/index';

import styles from './index.module.css';

export const DIRECTIONS = {
  UP: 'up',
  RIGHT: 'right',
  DOWN: 'down',
  LEFT: 'left',
};

function ArrowButton(props) {
  return (
    <Button
      {...props}
      className={`${styles.button} ${props.className || ''}`}
      light={props.light}>
      <span
        className={`${styles[props.direction || DIRECTIONS.UP]} ${
          styles.arrow
        } ${props.light ? styles.light : ''}`}
      />
    </Button>
  );
}

ArrowButton.propTypes = {
  direction: PropTypes.string,
  light: PropTypes.bool,
};

export default ArrowButton;
